import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { useResetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase"
import quizPreinfoState from "../../recoil/quizPreinfo"
import { quizResponseListState } from "../../recoil/QuizPage/atoms"

const useHandlePopstate = () => {
  const navigate = useNavigate()
  const resetQuizPhase = useResetRecoilState(quizPhaseState)
  const resetQuizPreinfo = useResetRecoilState(quizPreinfoState)
  const resetQuizResponseList = useResetRecoilState(quizResponseListState)

  useEffect(() => {
    const handlePopstate = () => {
      // window.history.pushState(null, "", window.location.href)
      toast(
        <div>
          <p>
            진행 중이던 내용이 유실될 수 있습니다. 진행 중인 내용을 임시
            저장하시겠습니까?
          </p>
          <button
            onClick={() => {
              // 임시 저장 DB로 보내기
              resetQuizPhase()
              resetQuizPreinfo()
              resetQuizResponseList()
              navigate(-2)
            }}
          >
            임시 저장
          </button>
          <button
            onClick={() => {
              resetQuizPhase()
              resetQuizPreinfo()
              resetQuizResponseList()
              localStorage.removeItem("quizPreinfo")
              localStorage.removeItem("quizProgress")
              localStorage.removeItem("quizResponseList")
              navigate(-2)
            }}
          >
            저장하지 않기
          </button>
        </div>,
        {
          position: "top-right",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      )
    }
    window.history.pushState(null, "", window.location.href)
    window.addEventListener("popstate", handlePopstate)

    return () => {
      window.removeEventListener("popstate", handlePopstate)
    }
  }, [navigate, resetQuizPhase, resetQuizPreinfo, resetQuizResponseList])
}

export default useHandlePopstate
